__turbopack_context__.v({
  "asSupplied": "QY-p9G_asSupplied",
  "asSuppliedLabel": "QY-p9G_asSuppliedLabel",
  "chevron": "QY-p9G_chevron",
  "chevronOpen": "QY-p9G_chevronOpen",
  "corroborated": "QY-p9G_corroborated",
  "firstSeen": "QY-p9G_firstSeen",
  "langBadge": "QY-p9G_langBadge",
  "moreButton": "QY-p9G_moreButton",
  "moreLink": "QY-p9G_moreLink",
  "originBadge": "QY-p9G_originBadge",
  "panelCell": "QY-p9G_panelCell",
  "panelHeader": "QY-p9G_panelHeader",
  "panelInner": "QY-p9G_panelInner",
  "propLabel": "QY-p9G_propLabel",
  "single": "QY-p9G_single",
  "sourceCell": "QY-p9G_sourceCell",
  "sourceId": "QY-p9G_sourceId",
  "statement": "QY-p9G_statement",
  "statementList": "QY-p9G_statementList",
  "statementListCorroborated": "QY-p9G_statementListCorroborated",
  "statementMain": "QY-p9G_statementMain",
  "statementMeta": "QY-p9G_statementMeta",
  "statementSource": "QY-p9G_statementSource",
  "trigger": "QY-p9G_trigger",
  "triggerIcon": "QY-p9G_triggerIcon",
  "triggerRow": "QY-p9G_triggerRow",
  "truncationNote": "QY-p9G_truncationNote",
  "valueGroup": "QY-p9G_valueGroup",
  "valueGroupHead": "QY-p9G_valueGroupHead",
  "valueText": "QY-p9G_valueText",
});
